function secondimageRedirect(e){
    const target = e.target;
    const card = target.closest('.card');
    const productUrl = card.dataset.url;
    const card_count = Number(card.dataset.count);
    const card_total_media = card.querySelector('.card__media .media').children.length;
    console.log(card_count);
    if(window.innerWidth < 750 && card_count === 0 && card_total_media == 2){
        card.querySelector('.card__media').classList.add('second_image_show');
        card.setAttribute('data-count','1');
    } else {
        window.location.replace(productUrl);
    }
}

function autoplayFirstVideo() {
    
}